import { IonButton } from "@ionic/react";
import { TestType } from "../../models/Enums";

interface Props {
  setParticipantWithinBox: Function;
}
const ParticipantWithinBoxModal: React.FC<Props> = ({
  setParticipantWithinBox,
}) => {
  const selectedAssessment = sessionStorage.getItem("selectedAssesment");
  return (
    <>
      {sessionStorage.getItem("selectedAssesment") === "55" ||
      sessionStorage.getItem("selectedAssesment") === "2" ||
      sessionStorage.getItem("selectedAssesment") === "1" ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <p
            style={{
              fontSize: "55px",
              fontWeight: "700",
              lineHeight: "74.9px",
              textAlign: "center",
              color: "white",
              paddingBottom: "56px",
            }}
          >
            Participant Detected!
          </p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="401"
            height="400"
            viewBox="0 0 401 400"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M200.922 0C90.4649 0 0.921875 89.543 0.921875 200C0.921875 310.457 90.4649 400 200.922 400C311.379 400 400.922 310.457 400.922 200C400.922 89.543 311.379 0 200.922 0Z"
              fill="#0F854C"
            />
            <path
              d="M275.922 150L175.922 250L125.922 200"
              stroke="white"
              stroke-width="24"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      ) : (
        <div className="generic-assesment-text-modal">
          <div className="align-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="104"
              height="105"
              viewBox="0 0 104 105"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M51.9995 0.81543C23.4549 0.81543 0.314941 23.9554 0.314941 52.5C0.314941 81.0446 23.4549 104.185 51.9995 104.185C80.5441 104.185 103.684 81.0446 103.684 52.5C103.684 23.9554 80.5441 0.81543 51.9995 0.81543Z"
                fill="#43BA73"
              />
              <path
                d="M67.5049 42.1631L46.8311 62.8369L36.4941 52.5"
                stroke="white"
                strokeWidth="10.3369"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">
            Participant is within{" "}
          </h1>
          <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">
            the bounding box!{" "}
          </h1>
          {Number(selectedAssessment) === TestType.five_x_sit_stand && (
            <h1 className="fz-30 fw-700 lh-normal mb-0 align-center chair-text">
              Make sure the chair
            </h1>
          )}
          {Number(selectedAssessment) === TestType.five_x_sit_stand && (
            <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">
              is safely positioned
            </h1>
          )}
          {Number(selectedAssessment) === TestType.five_x_sit_stand && (
            <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">
              behind participant.
            </h1>
          )}
        </div>
      )}
    </>
  );
};
export default ParticipantWithinBoxModal;
